// src/locales/ta/header.js
export const header = {
    searchPlaceholder: "ஆர்டர்கள், தயாரிப்புகள், வாடிக்கையாளர்களைத் தேடுங்கள்...",
    search: "தேடு",
    notifications: "அறிவிப்புகள்",
    markAllRead: "அனைத்தையும் படித்ததாகக் குறி",
    viewAllNotifications: "அனைத்து அறிவிப்புகளையும் காண்க",
    noNotifications: "அறிவிப்புகள் இல்லை",
    profileSettings: "சுயவிவர அமைப்புகள்",
    accountSettings: "கணக்கு அமைப்புகள்",
    businessSettings: "வணிக அமைப்புகள்",
    roleManagement: "பங்கு மேலாண்மை",
    areYouSureLogout: "நீங்கள் நிச்சயமாக வெளியேற விரும்புகிறீர்களா?",
    searchResults: "தேடல் முடிவுகள்",
    searching: "தேடுகிறது...",
    searchError: "ஆர்டர்களைத் தேட முடியவில்லை",
    noOrdersFound: "ஆர்டர்கள் கிடைக்கவில்லை",
    searchHint: "ஆர்டர் எண், தொலைபேசி எண் அல்லது ஏர்வேபில் எண் மூலம் தேடுங்கள்",
    viewAllResults: "அனைத்து முடிவுகளையும் காண்க",
    mobileSearchHint: "ஆர்டர் எண், தொலைபேசி எண் அல்லது ஏர்வேபில் எண்ணை உள்ளிடவும். முடிவுகளைக் காண Enter அழுத்தவும்."
}